<template>
	<div class="action-block-icon">
		<div v-if="isWidget" class="flex-centerize height-100">
			<SIcon v-if="isMiniApp" :width="25" :height="25" :name="miniAppType" eager />
			<SIcon v-else :width="24" :height="24" :name="'widgets'" eager />
		</div>
		<div v-else class="flex-centerize height-100">
			<!-- <SIcon :width="24" :height="24" v-if="isEndRun" name="end-flag" />
			<SIcon v-else :width="24" :height="24" :name="serviceSlug" /> -->
			<AppIcon :width="24" :height="24" :name="serviceSlug" />
		</div>
	</div>
</template>

<script>
import AppService from '@/utils/AppService';
import { ServiceSlugs } from '@ply-io/ply-front-shared-utilities';

export default {
	name: 'WidgetTypeIcon',
	props: { serviceSlug: { type: String }, miniAppType: { type: String } },
	computed: {
		isWidget() {
			return AppService.isSlugOfWidget(this.serviceSlug);
		},
		isMiniApp() {
			return this.isWidget && !!this.miniAppType;
		},
		isEndRun() {
			return this.appData?.service_slug === ServiceSlugs.EndRun;
		},
	},
};
</script>

<style lang="scss" scoped>
.action-block-icon {
	height: 100%;
	width: 100%;
	background: transparent;
	border-radius: 1px;
	border-color: transparent;
	position: relative;
	overflow: hidden;
}
</style>
